import { PropsWithChildren, ReactElement } from 'react';

import { IffPanel } from '../IffPanel/IffPanel';
import { HeadingLevels, IressButton, IressIcon, IressInline, IressStack, IressText } from '@iress-oss/ids-components';

export const Section = ({
    heading,
    testId = 'section-wrapper',
    children,
    headerButtonIcon,
    headerButtonCallback,
    headingLevel,
}: PropsWithChildren<{
    heading: string;
    testId?: string;
    headerButtonIcon?: string;
    headerButtonCallback?: () => void;
    headingLevel?: HeadingLevels;
}>): ReactElement => (
    <IressStack gutter={headerButtonIcon ? 'sm' : 'xs'} data-testid={testId} className="section-stack">
        <IressText element={headingLevel ?? 'h2'} noGutter data-testid={`${testId}__heading`}>
            {headerButtonIcon ? (
                <IressInline horizontalAlign="between" verticalAlign="middle">
                    <span data-testid={`${testId}-heading`}>{heading}</span>
                    <IressButton
                        mode="tertiary"
                        onClick={headerButtonCallback}
                        data-testid={testId ? `${testId}__heading-button` : undefined}
                    >
                        <IressIcon name={headerButtonIcon} />
                    </IressButton>
                </IressInline>
            ) : (
                <span data-testid={`${testId}-heading`}>{heading}</span>
            )}
        </IressText>
        <IffPanel>{children}</IffPanel>
    </IressStack>
);
